import { render, staticRenderFns } from "./Descendante.vue?vue&type=template&id=31855964&scoped=true"
import script from "./Descendante.vue?vue&type=script&lang=js"
export * from "./Descendante.vue?vue&type=script&lang=js"
import style0 from "./Descendante.vue?vue&type=style&index=0&id=31855964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31855964",
  null
  
)

export default component.exports